// extracted by mini-css-extract-plugin
module.exports = {"colorSwatch":"ColorSwatch_colorSwatch__1PAw7","box":"ColorSwatch_box__2TX60","title":"ColorSwatch_title__3HMmw","color":"ColorSwatch_color__3bENG"};